import UserGuide from "./SVG/user-guide.svg?react";

const UserGuideIcon = () => {
  return <UserGuide />;
};

export default UserGuideIcon;
